/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 12.11.25
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class ContactDetailsItem extends BaseObject {

	name: string = null
	title: string = null
	email: string = null
	phone: string = null
	address: string = null


	constructor(options) {
		super(options);
		this.applyOptions(options)
	}

	setFromUserProfile(userProfile) {
		if(!userProfile){
			console.warn("ContactDetailsItem.setFromUserProfile: userProfile is null. Skipping...")
			return
		}
		this.name = userProfile.name;
		this.title = userProfile.title;
		this.address = userProfile.getPrimaryAddressFormatted();
		this.phone = userProfile.primaryPhone;
		this.email = userProfile.email;
	}
}
